<template>
    <div style="width: 100%">
        <h3 class="attribute_titel header-row mb-3">
            Eintragstyp
            <span
                class="tag is-danger is-light dangerTag"
                v-if="!$v.entry_type.required"
            >
                Eintragstyp benötigt!
            </span>
        </h3>
        <div
            class="columns mb-0 is-flex is-flex-wrap-wrap
                is-justify-content-flex-start"
            id="entryTypeContainer"
            style="width: 100%"
        >
            <div
                v-for="entryType in entryTypes"
                :key="entryType.id"
                class="column is-flex-grow-0 is-flex-shrink-0
                    is-flex is-align-items-center entry-type-option"
                style="flex-basis: initial"
            >
                <b-radio
                    v-model="entry_type"
                    v-on:input="$v.entry_type.$touch"
                    :native-value="entryType"
                    v-bind:style="{
                        color: entryType.attributes.color,
                    }"
                >
                    <span
                        class="tag m-0 is-dark is-rounded tagContainer"
                        style="float: right; width: fit-content"
                        v-bind:style="{
                            'background-color': entryType.attributes.color,
                            color: getColor(entryType.attributes.color),
                        }"
                    >
                        {{ entryType.attributes.name }}
                    </span>
                </b-radio>
                <InfoPopover
                    :info="entryType.attributes.info"
                    :info-url="entryType.attributes.infoUrl"
                />
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Component for the display of entry types.
 * @displayName EntryTypes
 */

import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { textColorForBackground } from "@/lib/Color";
import InfoPopover from "@/components/helper/InfoPopover";

export default {
    name: "EntryTypes",
    components: { InfoPopover },
    props: ["diaryEntryType", "setEntryType"],
    validations: {
        entry_type: {
            required,
        },
    },
    computed: {
        ...mapGetters({
            unfilteredEntryTypes: "entrytypes/getEntryType",
        }),
        entryTypes() {
            return this.unfilteredEntryTypes.filter(
                (config) => config.attributes.deleted !== true
            );
        },
        entry_type: {
            set(value) {
                this.setEntryType(value);
            },
            get() {
                return this.diaryEntryType;
            },
        },
    },
    methods: {
        getColor(hex) {
            return textColorForBackground(hex);
        },
    },
    mounted() {
        this.entryTypes.forEach((item) => {
            if (item.attributes.isStandardEntryType) {
                this.entry_type = item;
            }
        });
    },
};
</script>

<style lang="scss" scoped>
.attribute_titel {
    margin-top: 12px;
    font-weight: bold;
}

/* The required badge sits right-aligned in the header row instead of
   below the options. */
.header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-row .tag {
    font-weight: normal;
}

.entry-type-option .info-popover {
    align-self: flex-start;
    margin-left: -0.35em;
    margin-top: -0.25em;
}

.tagContainer {
    align-items: center;
    grid-area: tag;
    align-self: center;
    justify-self: end;
}

@media (max-width: 920px) {
    .tagContainer {
        align-items: center;
        grid-area: tag;
        justify-self: center;
    }
}

@media (max-width: 769px) {
    .columns:not(:last-child) {
        margin-bottom: 0;
    }

    .attribute_titel {
        margin: 0.5rem 0 !important;
    }

    .columns {
        display: flex;
        align-items: center;
        flex-direction: row;
        padding: 0px;
        margin: 0px;
    }

    .tagContainer {
        align-items: center;
        grid-area: tag;
        margin-right: 1em;
    }

    .column {
        padding: 0;
        margin: 0;
    }
}

@media (max-width: 450px) {
    .b-radio.radio + .radio {
        margin-right: 3px;
        margin-left: 2px;
    }
}

@media (max-width: 500px) {
    #entryTypeContainer {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0.5em;
    }
}

@media (max-width: 400px) {
    #entryTypeContainer {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 0.5em;
    }
}
</style>
